import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-select',
  templateUrl: './demo-select.component.html',
  styleUrls: ['./demo-select.component.less']
})
export class DemoSelectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
